import { render, staticRenderFns } from "./EditorWrapper.vue?vue&type=template&id=2d45f966&scoped=true&"
var script = {}
import style0 from "./EditorWrapper.vue?vue&type=style&index=0&id=2d45f966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45f966",
  null
  
)

export default component.exports